import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { get } from 'lodash'

import ReportContainer from "../ReportContainer";
import BadgingContent from "./BadgingContent";

import "./index.scss";

import { fetchBadges } from "../../../../services/badging/fetchBadges/fetchBadges";
import { generateBadgingReport } from "../../util/generators/generateBadgingReport";
import { BADGE_TYPE } from "../../../../services/badging/constants";

export default function BadgingReport(props) {

  const [reportData, setReportData] = useState([]);
  const [status, setStatus] = useState(null);
  const roster = useSelector(state => state.reports.roster);
  const rosterStatus = get(roster, 'status.type')
  const classId = get(roster, 'ui.selections.classroom.id')

  useEffect(() => {
    fetchBadgingReport();
  }, [rosterStatus])

  return (
    <ReportContainer>
      <div className="badgingReport">
        <BadgingContent 
          reportData={reportData} 
          fetchReport={fetchBadgingReport}
          status={status} 
          history={props.history} 
        />
      </div>
    </ReportContainer>
  );
  
  async function fetchBadgingReport(params={}) {
    const {skipLoading} = params;
    if (rosterStatus !== 'COMPLETE') return;
    if (!roster.data || !roster.data.student) return;
    const students = roster.data.student;
    const studentIds = students.map(x => x.id);
    if (!skipLoading) setStatus('PENDING');
    try {
      const badgeData = await fetchBadges(studentIds);
      // filter out custom badges created for another class
      const filtered = badgeData.filter(x => x.badgeTypeId !== BADGE_TYPE.CUSTOM || x.classId == classId);
      const report = generateBadgingReport(filtered, students);
      setReportData(report);
      setStatus('DONE');
    } catch (e) {
      console.error(e);
      setStatus('ERROR');
    }
  }
}

